<template>
	<div>
		<h4 class="text-center p-0">Estadisticas por proveedor</h4>
		<b-form-row>
			<b-form-group class="col-md-3" label="Fecha servicio desde *">
				<b-form-datepicker
						locale="es"
						:class="{'active-filter':filters.pickupStartDate}"
						reset-button
						size="sm"
						v-model="filters.pickupStartDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Hasta *">
				<b-form-datepicker
						locale="es"
						:class="{'active-filter':filters.pickupEndDate}"
						reset-button
						size="sm"
						v-model="filters.pickupEndDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Proveedor">
				<multiselect
						:class="{'active-filter':filters.supplierId.length>0}"
						v-model="filters.supplierId"
						:options="suppliersOpts"
						label="text"
						track-by="value"
						multiple
						placeholder="Seleccione 1 opción"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Estado de servicio">
				<multiselect
						:class="{'active-filter':filters.status.length>0}"
						v-model="filters.status"
						:options="statusOpts"
						group-label="group"
						group-values="options"
						group-select
						multiple
						label="text"
						track-by="value"
						placeholder="Todos"
						taggable
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group class="col-lg-4" label="Aeropuertos">
				<multiselect
					:class="{'active-filter':filters.airport.length>0}"
					v-model="filters.airport"
					:options="airportsOpts"
					group-label="group"
					group-values="options"
					group-select
					multiple
					label="text"
					track-by="value"
					placeholder="Todos"
					:option-height="10"
					taggable
				/>
			</b-form-group>
			<b-form-group class="col-lg-4" label="Destinos">
				<multiselect
					:class="{'active-filter':filters.destination.length>0}"
					v-model="filters.destination"
					:options="destinationsOpts"
					group-label="group"
					group-values="options"
					group-select
					multiple
					label="text"
					track-by="value"
					placeholder="Todos"
					taggable
				/>
			</b-form-group>
		</b-form-row>

		<b-form-row>

			<b-col class="text-right mt-2" >
				<b-overlay :show="loadingExport"  no-wrap rounded> </b-overlay>
				<b-button v-if="$hasPermission('report.show')" @click="search()" variant="primary" class="mr-2"><md-icon icon="search"/> Generar</b-button>
				<b-button v-if="$hasPermission('report.export.xls')" @click="excel()" variant="success" class="mr-2"><md-icon icon=""/>Xls</b-button>
			</b-col>
		</b-form-row>


		<b-row v-if="loading">
			<div >
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
			</div>
		</b-row>
		<b-row  v-if="!loading" class="mt-4" >
			<b-col class="col-md-12">
				<div id="msg">
					<h6 v-if="totalRecords===-1">Seleccione las opciones para generar el reporte</h6>
					<h6 v-if="totalRecords===0">No se encontraron registros</h6>
				</div>
			</b-col>
			<b-tabs class="col-12" content-class="mt-3" fill v-if="items.length>0">
				<b-tab title="" active>
					<template #title>
						<md-icon icon="table_rows" /> Tabla
					</template>
					<div class="table-responsive async-tables">
						<h6>Rides: <b>{{this.totalTransportServices}}</b>, Proveedores: <b>{{this.items.length}}</b></h6>
						<b-table striped hover :items="items" :fields="fields"></b-table>
					</div>
				</b-tab>
				<b-tab title="">
					<template #title>
						<md-icon icon="bar_chart" /> Grafica
					</template>
					<chart-supplier :series="series" :categories="categories"></chart-supplier>
				</b-tab>
			</b-tabs>

		</b-row>
	</div>
</template>

<script>
	import api from '../../../../api.js'
	import Multiselect from 'vue-multiselect';
	import moment from 'moment'
	import chartSupplier from "./ChartSupplierStadistics"
	export default {
		name: "supplier-stadistics",
		components:{Multiselect,chartSupplier},
		data(){
			let pickUpStart = moment().subtract(1, 'months').format("YYYY-MM-DD");
            let pickUpEnd = moment().format("YYYY-MM-DD");
			return {
				loading:false,
				loadingExport:false,
				html:"",
				totalRecords:-1,
				codeReport : "supplier-stadistics",
				filters:{
					status:[],
					pickupStartDate:pickUpStart,
					pickupEndDate:pickUpEnd,
					supplierId: [],
					airport:[],
					destination:[]
				},
				items:[],
				series:[],
				categories:[],
				totalTransportServices:0
			}
		},
		methods:{
			isEmpty(val){
				return (val ===null || val === undefined || val==="");
			},
			validate(){
				try{
					if(this.isEmpty(this.filters.pickupStartDate)){
						throw "Fecha inicio es requerido";
					}
					if(this.isEmpty(this.filters.pickupEndDate)){
						throw "Fecha fin es requerido";
					}

			}catch(err){
				this.$root.showAlert(err,{variant:'danger'})
				return false;
			}
			return true;
			},
			search(){
				if(!this.validate())return;
				this.items=[];
				this.loading = true
				this.categories = [];
				this.series     = [];
				this.totalTransportServices=0;
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filtersClean,
					}
				}).then((res) => {
					if(res.status==200){
						this.items      = res.data.table;
						this.categories = res.data.chart.categories;
						this.series     = res.data.chart.series;
						this.totalTransportServices     = res.data.totalTransportServices;
					}
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{
					this.loading = false
					this.totalRecords = this.items.length;
				});
			},
			excel(){
				if(!this.validate())return;
				this.loadingExport = true
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filtersClean,
						format:"excel"
					},
					responseType: "blob"
				}).then((res) => {
					this.$root.downloadExcel(res,"stadistics");
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loadingExport = false});
			},


		},
		mounted() {
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['suppliersOpts','airportsOpts','destinationsOpts']})
		},
		computed:{
			airportsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.airportsOpts}]
			},
			destinationsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.destinationsOpts}]
			},
			suppliersOpts(){
				let aux = [...this.$root.auxVars.suppliersOpts];
				return aux ;
			},
			statusOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.transportServiceStatusOpts}]
			},
			fields(){
				return [
					{key: 'name',label: 'Proveedor'},
					{key: 'totals.resume.assigned',label: 'Asignados'},
					{key: 'totals.resume.confirmed',label: 'Aceptados'},
					{key: 'totals.resume.rejected',label: 'Rechazados'},
					{key: 'pendientes',label: 'PendientesActual'},
					{key: 'confirmados',label: 'ConfirmadosActual'},

				]
			},
			filtersClean() {
				return {
					pickupStartDate: this.filters.pickupStartDate,
					pickupEndDate: this.filters.pickupEndDate,
					supplierId: this.filters.supplierId.map(aux => aux.value),
					status: this.filters.status.map(aux => aux.value),
					airport: this.filters.airport.map(aux => aux.value),
					destination: this.filters.destination.map(aux => aux.value),


				};
			}
		}

	}
</script>

<style scoped>

</style>
